import { SVGProps, Ref, forwardRef } from 'react';

export const IngotsFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M4.205 11.602c.474.006.768.03 1.026.13l.126.053c.29.134.543.336.74.589l.08.114c.177.281.294.665.5 1.345L7.333 16H0l.656-2.167c.206-.68.323-1.064.5-1.345l.08-.114c.197-.253.451-.455.74-.589l.127-.054c.345-.131.752-.131 1.564-.131z"
                fill="currentColor"
            />
            <path
                d="M11.674 11.467c1.44 0 2.161 0 2.694.398.533.399.736 1.09 1.143 2.473L16 16H8.797l-.78-2.573c-.202-.666-.39-1.365-.814-1.911q-.02-.025-.04-.05z"
                fill="currentColor"
            />
            <path
                d="M8.785 5.733c-.414.544-.602 1.235-.802 1.894l-.8 2.64H0l.49-1.663c.406-1.382.61-2.074 1.142-2.472.533-.399 1.253-.399 2.694-.399z"
                fill="currentColor"
            />
            <path
                d="M12.872 5.802c.473.006.768.03 1.026.13l.126.053c.29.134.544.336.74.59l.04.057c.251.426.433 1.043.707 1.972l.47 1.596H8.667l.656-2.167c.206-.68.323-1.064.5-1.345l.08-.114c.197-.253.451-.455.74-.589l.127-.053c.345-.132.752-.132 1.564-.132z"
                fill="currentColor"
            />
            <path
                d="M11.674 0c1.44 0 2.161 0 2.694.398.533.4.736 1.09 1.143 2.473L16 4.533H8.837l-.82-2.706C7.825 1.194 7.643.533 7.262 0z"
                fill="currentColor"
            />
            <path
                d="M4.205.002c.474.006.767.03 1.026.13l.126.054a2 2 0 0 1 .74.588l.08.115c.177.28.293.664.5 1.344L7.333 4.4H.039l.45-1.529C.896 1.49 1.1.797 1.632.398c.501-.375 1.17-.396 2.45-.397z"
                fill="currentColor"
            />
        </g>
    </svg>
));
IngotsFilledSize16Glyph.displayName = 'IngotsFilledSize16Glyph';
